module.exports = __webpack_public_path__ + "static/description-image-98c7058dbc0fbfe9cc7ffdfc7a3d2fe9.jpg";